import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";

import "./i18n/i18n";

import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "assets/demo/demo.css";
import "assets/css/custom.css";
import "assets/css/scheduleTable.css";
// redux

import  store,{ persistor } from './store/index';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AppRoutes } from "AppRoutes";
import Api from "services/api"
import { uri } from "constants/common";
import toast, { Toaster } from "react-hot-toast";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById("root"));

Api.init({ url: uri });
const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<div>loading...</div>} persistor={persistor}>
        <AppRoutes />
         <Toaster position="top-right"/>
      </PersistGate>
    </Provider>
  )
}
root.render(
  <App />
);;

serviceWorkerRegistration.unregister();